import {request,newVue,requestMsg} from "./request";
export {newVue}

export function getMarketingMerchantsList(pageNum,pageSize) {
  return request({
    url: '/marketingMerchants/getMarketingMerchantsList',
    params: {
      pageNum: pageNum,
      pageSize: pageSize
    }
  })
}

export function delByMarketingMerchantsId(id) {
  return requestMsg({
    url: '/marketingMerchants/delByMarketingMerchantsId',
    params: {
      marketingMerchantsId:id
    }
  })
}

export function getMarketingMerchantsById(id) {
  return request({
    url: '/marketingMerchants/getById',
    params: {
      marketingMerchantsId:id
    }
  })
}

export function updateMarketingMerchants(marketingMerchants) {
  return requestMsg({
    url: '/marketingMerchants/updateMarketingMerchants',
    data: JSON.stringify(marketingMerchants),
    method: "POST",
    headers : {"Content-Type" : "application/json;charset=utf-8"},
  })
}
